
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as giAcnlJUD_45Ct5ft36_45idsPqn6IMOdCe834FZdw_45Fx_45uYMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexfRY80Ydd74LpTr5ulkphJtSAYNsnEslDrCKNPt22nw8Meta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search1rp3i5_A4E8cstsXWCw9CS7Y8S_45BnwJl8ahFssAd83oMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexVY3fwexQSeqFya_4545L2OgxfhOfQbKv4nrWQ_zb6I7ikMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93euvvbFNas2kg23MmsBCIaNs7ZZXHT94O4wNEq97lHyIMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexJnsPg5rp_3Ix6AOvwuxyg7DI44mcka86C6i8rC5rnakMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93EymyIz9_45aBqgV7M7CTmzzJ8TSvqLob2AOwxM76zyDEsMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexcADlDQUYmFs8D2hQR0GJOq3gRwLCAeMZEicQZM4sYwwMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93AZFpnHszKVgQpCFJ3ohLetNFe8TBLP3KN3di2gxqrX0Meta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexs2zLRTneII7bQTqq26M69OjyGE_Dr0bgtp9J0sufscMMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexfcjFPa_bM_454D0padJkX8gztCFSpMzoXyB7_45xwuQYgoYMeta } from "/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexJnsPg5rp_3Ix6AOvwuxyg7DI44mcka86C6i8rC5rnakMeta || {},
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexcADlDQUYmFs8D2hQR0GJOq3gRwLCAeMZEicQZM4sYwwMeta || {},
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexs2zLRTneII7bQTqq26M69OjyGE_Dr0bgtp9J0sufscMMeta || {},
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexfcjFPa_bM_454D0padJkX8gztCFSpMzoXyB7_45xwuQYgoYMeta || {},
    component: () => import("/codebuild/output/src3363874161/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]